import {NavigationTreeItem} from '~ui/components/NavigationTree/types';

export function getTreeItemKey(item: NavigationTreeItem) {
    if (item.isLoader) {
        return `${item.slug}-loader-${item.type}`;
    }

    if (item.isExpander) {
        return `${item.slug}-expander`;
    }

    return item.slug;
}
